import axios from "axios"

const apiNode = axios.create({
  baseURL:"https://api-tributei-x7u66.ondigitalocean.app/"
  // baseURL:"http://localhost:8000/"
})

export default apiNode
